import { SortSportEnum } from "@/components/homepage/SortSport";
import type { Round } from "@roman/shared/types/Round";

export const sortRoundsByNumEntries = (roundsData: Round[]) => {
  return roundsData.sort((a, b) => {
    const isFullEntryA = a.numEntries === a.maxNumEntries;
    const isFullEntryB = b.numEntries === b.maxNumEntries;
    if (isFullEntryA === isFullEntryB) return 0;
    return isFullEntryA ? 1 : -1;
  });
};

export const getSortedRounds = (filteredRounds: Round[], selectedSortType: SortSportEnum): Round[] => {
  const resultRound: Round[] = [];
  switch (selectedSortType) {
    case SortSportEnum.EARLIEST_EVENT_DATE:
      resultRound.push(
        ...filteredRounds.sort((a, b) => {
          if (a.sportEventName === b.sportEventName) {
            return a.type === "Round0001" ? 1 : -1;
          }

          if (a.entryCloseTime === b.entryCloseTime) {
            return Number.parseInt(b.prizePool) - Number.parseInt(a.prizePool);
          }

          return a.entryCloseTime - b.entryCloseTime;
        }),
      );
      break;
    case SortSportEnum.HIGHEST_PRIZE_AMOUNT:
      resultRound.push(
        ...filteredRounds.sort((a, b) => {
          if (a.sportEventName === b.sportEventName) {
            return a.type === "Round0001" ? 1 : -1;
          }

          return Number.parseInt(b.prizePool) - Number.parseInt(a.prizePool);
        }),
      );
      break;
    case SortSportEnum.HIGHEST_ENTRY_FEE:
      resultRound.push(
        ...filteredRounds.sort((a, b) => {
          if (a.sportEventName === b.sportEventName) {
            return a.type === "Round0001" ? 1 : -1;
          }

          return Number.parseInt(b.entryFee) - Number.parseInt(a.entryFee);
        }),
      );
      break;
    case SortSportEnum.LOWEST_ENTRY_FEE:
      resultRound.push(
        ...filteredRounds.sort((a, b) => {
          if (a.sportEventName === b.sportEventName) {
            return a.type === "Round0001" ? 1 : -1;
          }

          return Number.parseInt(a.entryFee) - Number.parseInt(b.entryFee);
        }),
      );
      break;
    case SortSportEnum.NEWEST_TOURNAMENT:
      // TODO: sort by createdAt
      resultRound.push(...filteredRounds);
      break;
    case SortSportEnum.ROUND_0001:
      resultRound.push(...filteredRounds.filter((round) => round.type === "Round0001"));
      break;
    case SortSportEnum.ROUND_0002:
      resultRound.push(...filteredRounds.filter((round) => round.type === "Round0002"));
      break;
    default:
      resultRound.push(...filteredRounds);
  }

  return sortRoundsByNumEntries(resultRound);
};
